window.$ = window.jQuery = require('jquery');
window.Handlebars = require('handlebars');
window.Handlebars.registerHelper('knockDownObj', function(key) {
    return window.KNOCKDOWN_STYLING[key];
});

// need to make it global cause Briscoes used Swiper to on their custom block (featuredProduct-carousel)
window.Swiper = require('swiper/swiper-bundle');
window.noUiSlider = require('nouislider');

import './klevu/klevu'; // change this to "https://js.klevu.com/core/v2/klevu.js" as per https://community.klevu.com/t/new-release-klevu-javascript-library-2-x/588
import './klevu/klevu-quick';
import './klevu/klevu-quick-promotion-banner';
import './klevu/klevu-landing';
import './klevu/klevu-facets';
import './klevu/klevu-landing-filter-left';
import './klevu/klevu-landing-sort';
import './klevu/klevu-landing-limit';
import './klevu/klevu-landing-filter-price-slider';
import './klevu/klevu-landing-filter-plu';
import './klevu/klevu-product-listing-block';
import './klevu/klevu-landing-mobile-sliding-filter';
import './klevu/klevu-landing-promotion-banner';
import './klevu/klevu-landing-init';
import './klevu/klevu-analytics-utils';
import './klevu/klevu-checkout-analytics-request';



// WEBPACK FOOTER //
// ./libs.js